export const FaqsData = [
  {
    id: "1",
    question: "How does the development process work?",
    ans: "My development process is designed to be transparent and collaborative. I start with a detailed discussion about your requirements, followed by planning, development, testing, and deployment. Communication is key, and I ensure you're involved at every step.",
  },
  {
    id: "2",
    question: "How long does it take to build a mobile application?",
    ans: "The timeline for building a mobile application can vary based on its complexity, features, and design specifics. A simple app can take 3-4 months, while more complex applications may require 6-12 months. I strive to provide realistic timelines based on your project's needs.",
  },
  {
    id: "3",
    question: "How much will my website cost?",
    ans: "The cost of a website can vary significantly depending on the project's scope, including design, functionality, and content requirements. While a basic website might start at around $1,000, more intricate, feature-rich sites could significantly exceed that, depending on your specific needs. I offer a detailed quote after fully understanding the scope of your project to ensure transparent pricing.",
  },
  {
    id: "4",
    question: "Can I see my website during the development process?",
    ans: "Absolutely! I encourage feedback by providing access to a staging environment where you can see your website take shape in real-time. This ensures the final product aligns perfectly with your vision.",
  },
  {
    id: "5",
    question: "Will my website be mobile-friendly?",
    ans: "Yes, making your website mobile-friendly is a top priority. I design and develop all websites with a responsive framework that automatically adjusts to fit the screen size of any device, ensuring an optimal viewing experience for all visitors.",
  },

];
